// extracted by mini-css-extract-plugin
export var himage = "home-img-module--himage--3cd97";
export var himg = "home-img-module--himg--97b37";
export var journ_tag = "home-img-module--journ_tag--18c2c";
export var twoimg_vlink = "home-img-module--twoimg_vlink--6df3a";
export var video = "home-img-module--video--ccabf";
export var vidnoc = "home-img-module--vidnoc--16e29";